module.exports = __webpack_public_path__ + "img/s-mob-2.b0e20cf1.webp";